var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Teams_svg__clip0_3076_45818)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "var(--secondary-green-200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 22,
    height: 22,
    rx: 2,
    fill: "#4AA147"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.605 12.515a1.772 1.772 0 01-1.636 1.121c-.978 0-1.77-.814-1.77-1.818S16.99 10 17.968 10c.908 0 1.656.701 1.759 1.605 2.09.589 3.769 2.2 4.494 4.276a.458.458 0 01-.268.582.44.44 0 01-.566-.275c-.615-1.763-2.024-3.138-3.783-3.673zm-4.614.066a.462.462 0 01-.133.628 5.916 5.916 0 00-2.493 3.622 6.078 6.078 0 00-.151 1.408A1.81 1.81 0 0113.542 20c0 1.004-.793 1.818-1.771 1.818-.978 0-1.771-.814-1.771-1.818 0-.847.565-1.56 1.328-1.761v-.057c0-.536.06-1.057.174-1.558a6.825 6.825 0 012.877-4.18.436.436 0 01.612.137zM22.396 20c0 .487.186.929.49 1.255-1.011 1.7-2.835 2.836-4.917 2.836a5.66 5.66 0 01-4.028-1.688.435.435 0 00-.626.006.463.463 0 00.006.643A6.533 6.533 0 0017.97 25c2.4 0 4.501-1.307 5.668-3.265.167.054.345.083.53.083.978 0 1.77-.814 1.77-1.818s-.792-1.818-1.77-1.818-1.771.814-1.771 1.818zm-.886-1.818c0 2.008-1.586 3.636-3.542 3.636-1.956 0-3.541-1.628-3.541-3.636s1.585-3.636 3.541-3.636 3.542 1.628 3.542 3.636z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Teams_svg__clip0_3076_45818"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}
export default SvgTeams;